import React from 'react';
import { CommonHash } from 'app/types';
import styles from '../LandingForm.module.scss';
import ImageElement from './ImageElement';

import { TitleComponentForm } from './TitleComponentForm';

interface ComponentFormProps {
  landing_cmp: CommonHash;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  index: number;
}

const HeroBannerForm = ({
  landing_cmp,
  handleChange,
  index,
}: ComponentFormProps): React.ReactElement => {
  const name = `landing_components[${index}]`;

  return (
    <>
      <div className={styles.group}>
        <ImageElement component={landing_cmp} name={name} handleChange={handleChange} />
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['style']`}>Style</label>
        <select
          name={`landing_components[${index}].config['style']`}
          onChange={handleChange}
          value={landing_cmp.config ? landing_cmp.config['style'] : 'normal'}
        >
          <option value="normal">Normal</option>
          <option value="homepage">Homepage</option>
          <option value="reverse">Reverse</option>
        </select>
      </div>
      <TitleComponentForm landing_cmp={landing_cmp} handleChange={handleChange} index={index} />
    </>
  );
};

export default HeroBannerForm;
